<template>
    <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
        <router-link to="/" class="navbar-item">
        <img src="@/assets/catIcon.png"><span class="text_title" style="padding-left:4px;font-size:1.1em;font-weight:bold;color:#27546A;">Emotion Diary</span>
        </router-link>

        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" v-bind:class="{ 'is-active': menuActive }" @click="menuToggle()" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        </a>
    </div>

    <div id="navbarBasicExample" class="navbar-menu" v-bind:class="{ 'is-active': menuActive }">
        <div class="navbar-start">
            <a class="navbar-item">
                <router-link class="navbar-item" to="/home"><i class="fas fa-edit"></i> HOME</router-link>
            </a>
            <a class="navbar-item">
                <router-link class="navbar-item" :to="{ name: 'archiveMonth', params:{ id_year: today.today_year, id_month: today.today_month }}"><i class="fas fa-book"></i> ARCHIVE</router-link>
            </a>
            <a class="navbar-item">
                <router-link class="navbar-item" :to="{ name: 'statisticsMonth', params:{ id_year: today.today_year, id_month: today.today_month}}"><i class="fas fa-chart-pie"></i> DATA</router-link>
            </a>
        </div>

        <div class="navbar-end">
        <div class="navbar-item">
            <router-link class="navbar-item" to="/payment"><i class="far fa-credit-card"></i>登録情報 </router-link>
            <b-dropdown v-if="userStatus" position="is-bottom-left" aria-role="list">
                <button class="button is-info" outlined slot="trigger">
                    <span style="font-weight:bold;">設定</span>
                    <b-icon icon="menu-down"></b-icon>
                </button>

                <b-dropdown-item aria-role="listitem">
                    <b-button class="is-text dropdown-item"  style="font-size:1em;padding:0px;font-weight:bold;" @click="logout">
                        ログアウト
                    </b-button>
                </b-dropdown-item>
            </b-dropdown>

            <a class="navbar-item">
                
            </a>
            <div class="buttons">
                <router-link to="login">
                    <b-button v-if="!userStatus" class="button is-info" style="font-weight:bold;">
                        ログイン
                    </b-button>
                </router-link> 
            </div>
        </div>
        </div>
    </div>
    </nav>
</template>

<script>
import firebase from 'firebase/app'
import store from '@/store'
export default {
    data(){
        return{
            menuActive:false,
        }
    },
    computed: {
        userStatus() {
            return this.$store.getters.isSignIn;
        },
        user(){
            return this.$store.getters.user;
        },
        today(){
            return this.$store.getters.today_info;
        }
    },
    watch:{
        '$route' () {
            this.menuActive = false
        }
    },
    created(){
        firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
                store.commit('onAuthStateChanged', user);
                store.commit('onUserStatusChanged', user.uid ? true : false);
            }
        });
    },
    methods:{
        logout(){
            this.$buefy.dialog.confirm({
            message: 'ログアウトしますか？',
            onConfirm: () =>  
                firebase.auth().signOut().then(()=>{
                    this.$buefy.toast.open('ログアウトしました');
                    this.$router.go({ name: '/login' })
                })
            })
        },
        menuToggle(){
            this.menuActive = !this.menuActive;
        },
    }
}
</script>

<style scoped>
nav{
    font-size: 1.1em;
    background-color: #ECF3F1;
}

</style>

